import { Component, OnInit, Inject } from '@angular/core';
import { DiagnosisService } from '../../../employee-view/services/diagnosis.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { pipe } from 'rxjs';
import { map, filter, tap, debounceTime, distinctUntilChanged, switchMap, audit } from 'rxjs/operators';
// import { element } from '@angular/core/src/render3';
import { UntypedFormControl } from '@angular/forms';
import { runInThisContext } from 'vm';

@Component({
    selector: 'app-diagnosis-search',
    templateUrl: './diagnosis-search.component.html',
    styleUrls: ['./diagnosis-search.component.scss'],
    standalone: false
})
export class DiagnosisSearchComponent implements OnInit {

    public DiagnosisId: number;
    public code: string;
    public description: string;
    public selectedLevel: number;
    public IsLoading: boolean;
    public TableData: any;
    public records: any;
    public TableColumns: string[] = ['code', 'descripcion'];
    searchCode = new UntypedFormControl('');
    searchDescription = new UntypedFormControl('');
    searchKey: string;
    public selectionStack: Array<{ 'code': string, 'descripcion': string, 'Id': number; }>;
    AllowConfirm = false;
    loadSpinnerClass = "load-spinner";

    constructor(
        private diagnosisService: DiagnosisService,
        @Inject(MAT_DIALOG_DATA) public InputData: any,
        public dialogRef: MatDialogRef<DiagnosisSearchComponent>,
    ) {
        this.selectionStack = [];
    }

    ngOnInit() {
        this.LoadChapters(this.InputData.Tipo);
        this.searchCode.valueChanges
            .pipe(
                tap(text => {
                    if (text === null)
                        this.searchKey = "";
                    else
                        this.searchKey = text.trim();
                }),
                filter(x => x === null || x.trim().length >= 3 || x.trim().length == 0),
                tap(text => {
                    this.IsLoading = true;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((searchText: string) => {
                    if (searchText === null || searchText.length === 0) {
                        return this.diagnosisService.GetChapters(this.InputData.Tipo)
                            .pipe(
                                map(resp => {
                                    return resp.result.map(element => {
                                        return { 'code': null, 'descripcion': element.descripcion, 'Id': element.capitulo };
                                    });
                                })
                            );
                    } else {
                        return this.diagnosisService.FindDiagnosisByCode(this.InputData.Tipo, searchText)
                            .pipe(
                                map(resp => {
                                    let array = resp.result.map(element => {
                                        return { 'code': element.codigo, 'descripcion': element.descripcion, 'Id': element.id, 'level': element.level };
                                    });
                                    return array.sort(function (a: any, b: any) {
                                        return a.code.length - b.code.length;
                                    });
                                }));
                    }
                })
            )
            .subscribe(res => {
                this.TableData = res;
                this.IsLoading = false;
            }, err => {
                console.error(err);
            });

        this.searchDescription.valueChanges
            .pipe(
                tap(text => {
                    if (text === null)
                        this.searchKey = "";
                    else
                        this.searchKey = text.trim();
                }),
                filter(x => x === null || x.trim().length >= 4 || x.trim().length == 0),
                tap(text => {
                    this.IsLoading = true;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((searchText: string) => {
                    if (searchText === null || searchText.length === 0) {
                        return this.diagnosisService.GetChapters(this.InputData.Tipo)
                            .pipe(
                                map(resp => {
                                    return resp.result.map(element => {
                                        return { 'code': null, 'descripcion': element.descripcion, 'Id': element.capitulo };
                                    });
                                })
                            );
                    } else {
                        return this.diagnosisService.GetRecordForDescriptionSearch(this.InputData.Tipo, searchText)
                            .pipe(
                                map(resp => {
                                    let array = resp.result.map(element => {
                                        return { 'code': element.codigo, 'descripcion': element.descripcion, 'Id': element.id, 'level': element.level };
                                    });
                                    return array.sort(function (a: any, b: any) {
                                        return a.code.length - b.code.length;
                                    });
                                }));
                    }
                })
            )
            .subscribe(res => {
                this.TableData = res;
                this.IsLoading = false;
            }, err => {
                console.error(err);
            });


    }

    public OnsearchCodeClick() {
        this.searchDescription.setValue(null);

    }

    public OnsearchDescClick() {
        this.searchCode.setValue(null);

    }

    private PushToSelectionStack(element: { 'code': string, 'descripcion': string, 'Id': number; }) {
        if (this.selectionStack.length < 4) {
            this.selectionStack.push(element);
        }
    }

    private PopFromSelectionStack(index: number) {
        const lastIndex = (this.selectionStack.length === 0) ? -1 : this.selectionStack.length - 1;
        for (let i = lastIndex; i >= index; i--) {
            this.selectionStack.pop();
        }
    }

    private LoadChapters(type: string) {
        this.IsLoading = true;
        this.diagnosisService.GetChapters(type)
            .pipe(
                map(resp => {
                    return resp.result.map(element => {
                        return { 'code': null, 'descripcion': element.descripcion, 'Id': element.capitulo };
                    });
                })
            )
            .subscribe(resp => {
                this.TableData = resp;
                this.IsLoading = false;
            }, err => {
                console.error(err);
            });
    }

    private LoadGroups(type: string, chapterId: number) {
        this.IsLoading = true;
        this.diagnosisService.GetGroups(type, chapterId)
            .pipe(
                map(resp => {
                    return resp.result.map(element => {
                        return { 'code': null, 'descripcion': element.descripcion, 'Id': element.grupo };
                    });
                })
            )
            .subscribe(resp => {
                this.TableData = resp;
                this.IsLoading = false;
            }, err => {
                console.error(err);
            });
    }

    private LoadThreeDigitCode(type: string, groupId: number) {
        this.IsLoading = true;
        this.diagnosisService.GetThreeDigitGrops(type, groupId)
            .pipe(
                map(resp => {
                    return resp.result.map(element => {
                        return { 'code': element.codigo, 'descripcion': element.descripcion, 'Id': element.id };
                    });
                })
            )
            .subscribe(resp => {
                this.TableData = resp;
                this.IsLoading = false;
            }, err => {
                console.error(err);
            });
    }

    private LoadFourDigitCode(type: string, threeDigitId: number, parentItem: any) {
        this.IsLoading = true;
        this.diagnosisService.GetDiagnosisCodes(type, threeDigitId)
            .pipe(
                map(resp => {
                    return resp.result.map(element => {
                        return { 'code': element.codigo, 'descripcion': element.descripcion, 'Id': element.id, 'level': 4 };
                    });
                })
            )
            .subscribe(resp => {
                this.TableData = resp;
                if (parentItem !== null) {
                    this.TableData.push(parentItem);
                }
                this.TableData = this.TableData.sort(function (a: any, b: any) {
                    return a.code.length - b.code.length;
                });
                this.IsLoading = false;
            }, err => {
                console.error(err);
            });
    }

    public OnStackItemClick(index: number) {
        this.PopFromSelectionStack(index);
        let stackSize: number = this.selectionStack.length;
        if (stackSize < 3) {
            this.AllowConfirm = false;
            let topId = 0;
            if (stackSize > 0) {
                topId = this.selectionStack[stackSize - 1].Id;
            }
            switch (stackSize) {
                case 1:
                    {
                        this.LoadGroups(this.InputData.Tipo, topId);
                    }
                    break;
                case 2:
                    {
                        this.LoadThreeDigitCode(this.InputData.Tipo, topId);
                    }
                    break;
                case 0:
                    {
                        this.LoadChapters(this.InputData.Tipo);
                    }
                    break;
            }
        }
    }

    public Onclick(column) {
        if (this.searchKey === undefined || this.searchKey.length === 0) {
            this.PushToSelectionStack({ 'code': column.code, 'descripcion': column.descripcion, 'Id': column.Id });
            let stackSize: number = this.selectionStack.length;
            switch (stackSize) {
                case 1:
                    {
                        this.AllowConfirm = false;
                        this.LoadGroups(this.InputData.Tipo, column.Id);
                    }
                    break;
                case 2:
                    {
                        this.AllowConfirm = false;
                        this.LoadThreeDigitCode(this.InputData.Tipo, column.Id);
                    }
                    break;
                case 3:
                    {
                        this.AllowConfirm = false;
                        column.level = 3;
                        this.LoadFourDigitCode(this.InputData.Tipo, column.Id, column);
                    }
                    break;
                default:
                    {
                        this.SetSelectedColumn(column);
                        // this.ConfirmCodes();
                    }
                    break;
            }
        } else {
            this.SetSelectedColumn(column);
            // this.ConfirmCodes();
        }

    }

    private SetSelectedColumn(column: { Id: number; code: string; descripcion: string; level: number; }) {
        this.AllowConfirm = true;
        this.DiagnosisId = column.Id;
        this.code = column.code;
        this.description = column.descripcion;
        this.selectedLevel = column.level;
    }

    ConfirmCodes() {
        if (this.code) {
            this.diagnosisService.GetDiagnosisMinInfo(this.InputData.Tipo, this.DiagnosisId, this.selectedLevel)
                .subscribe(resp => {
                    this.dialogRef.close(
                        {
                            'diagnosisGroupId': resp.result.diagnosisGroupId,
                            'diagnosisType': resp.result.diagnosisType,
                            'diagnosis': resp.result.diagnosisDescription,
                            'diagnosisCode': resp.result.diagnosisCode,
                            'tipo': this.InputData.Tipo,
                            'te': resp.result.standardEstimatedTime
                        }
                    );
                }, err => {
                    console.error(err);
                });
        }
    }

    Cancel() {
        this.dialogRef.close();
    }
}
